
import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, ArrowLeftIcon } from '@paypalcorp/pp-react'

export default function BackButton(props) {
  return (
    <IconButton
      buttonType="tertiary"
      size="sm"
      svgIconComponent={ArrowLeftIcon}
      data-testid="back-button"
      aria-label={props.backtext}
      data-pa-click="back"
      {...props}
    />
  )
}

BackButton.propTypes = {
  backtext: PropTypes.string,
}
